import React, { Component } from 'react';
import './Tooltip.css';

class Tooltip extends Component {
    render() {
        let content = this.props.value.toString();

        if(this.props.getContent !== undefined){
            content = this.props.getContent(this.props.value);
        }

        return (
            <span className="tooltip">
                <span className="tooltip-item">
                    {this.props.children}
                </span>
                <span className="tooltip-content clearfix">
                    {content}
                </span>
            </span>
        );
    }
}

export default Tooltip;


// WEBPACK FOOTER //
// ./src/Tooltip.js